export const RECENTLY_PUBLISHED_CONTENT_THRESHOLD_IN_DAYS = 31;
